import { Collapse, Modal, Segmented } from "antd";
import React, { useState } from "react";
import { socialMediaLinksData } from "../../Utility/Contants/SocialMediaData";
import { SocialMediaIconAndLable } from "./SocialMediaIconAndLable";
import { GetSocialLinks } from "./GetSocialLinks";
import { GetActionLinks } from "./GetActionLinks";

export const AddSocialMedia = ({
  addSocialMediaModel,
  setAddSocialMediaModel,
}) => {
  const [activeTab, setActiveTab] = useState("SocialMedia");

  // Social Media Links Data
  const SocialMediaPlatforms = socialMediaLinksData.map((platform, index) => ({
    key: (index + 1).toString(),
    label: (
      <SocialMediaIconAndLable icon={platform.icon} name={platform.name} />
    ),
    children: <GetSocialLinks platformName={platform.name} />,
  }));

  return (
    <Modal
      title="Add Links"
      open={addSocialMediaModel}
      footer={null}
      onCancel={() => setAddSocialMediaModel(false)}
      centered
    >
      {/* Segmented Control for Switching Tabs */}
      <Segmented
        options={[
          {
            label: <div>Social Media</div>,
            value: "SocialMedia",
          },
          {
            label: <div>Custom Links</div>,
            value: "CustomLinks",
          },
        ]}
        size="middle"
        value={activeTab}
        onChange={(value) => setActiveTab(value)}
        className="mb-5"
        block
      />

      {/* Display the Corresponding Collapse Panel */}
      {activeTab === "SocialMedia" && <Collapse items={SocialMediaPlatforms} />}
      {activeTab === "CustomLinks" && <GetActionLinks />}
    </Modal>
  );
};
